import { useMemo } from 'react';
import { Nav } from 'react-bootstrap';
import { useChartWorkbenchLauncher } from './ChartWorkbenchLauncher';

const resolveWorkbenchShortcutLabel = () => {
	if (typeof navigator === 'undefined') return 'Ctrl+.';
	const platform = navigator.userAgentData?.platform || navigator.platform || navigator.userAgent;
	return /Mac|iPhone|iPad|iPod/i.test(platform) ? '⌘.' : 'Ctrl+.';
};

const ChartWorkbenchNavIcon = () => (
	<svg viewBox='1.9 3.3 12.2 9.8' fill='none' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
		<path d='M2.6 12.4V7.4' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
		<path d='M6.2 12.4V4' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
		<path d='M9.8 12.4V8.2' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
		<path d='M13.4 12.4V5.4' stroke='currentColor' strokeWidth='1.4' strokeLinecap='round' />
	</svg>
);

/** 顶栏图标：当前页打开图表工作台命令面板 */
const NavbarChartWorkbenchButton = () => {
	const launcher = useChartWorkbenchLauncher();
	const shortcutLabel = useMemo(() => resolveWorkbenchShortcutLabel(), []);

	if (!launcher?.canOpen) return null;

	const label = '图表工作台';
	const title = `打开图表工作台（${shortcutLabel}）`;

	return (
		<Nav.Item as='li' className='d-flex align-items-center'>
			<Nav.Link as='button' type='button' className='navbar-chart-workbench-btn' title={title} aria-label={label} onClick={launcher.openPalette}>
				<ChartWorkbenchNavIcon />
			</Nav.Link>
		</Nav.Item>
	);
};

export default NavbarChartWorkbenchButton;
